module.exports = __webpack_public_path__ + "img/banner-old.cedb7f19.jpg";